<template>
  <DeepDialog
    v-model="showDialog"
    fullscreen-on-mobile
    persistent
    :title="i18n.t('titles.send_reminder')"
    width="600"
    @keydown.esc="closeDialog"
  >
    <template #content>
      <div v-if="isSingle" class="text-black text-body-large mb-4">
        {{
          i18n.t('texts.send_reminder', {
            email: targets[0]?.email
          })
        }}
      </div>
      <div v-else>
        <div class="text-black text-body-large mb-4">
          {{ i18n.t('texts.send_reminders') }}
        </div>
        <ul class="d-flex flex-column ga-2">
          <li
            v-for="target in targets"
            :key="target.signeeId"
            class="text-body-medium"
          >
            {{ target.email }}
          </li>
        </ul>
      </div>
    </template>
    <template #actions>
      <VBtnSecondary
        data-test-id="close-resend-invitations"
        :text="i18n.t('buttons.close')"
        variant="outlined"
        @click="closeDialog"
      />
      <VBtnPrimary
        data-test-id="confirm-resend-invitations"
        :loading="sending"
        :text="i18n.t('buttons.send_reminder')"
        @click="confirmResend"
      />
    </template>
  </DeepDialog>
</template>

<script setup lang="ts">
import { DeepDialog } from '@deepcloud/deep-ui-lib';
import { useI18n } from 'vue-i18n';
import { useResendInvitations } from '@/composables/useResendInvitations';

const i18n = useI18n();
const { showDialog, sending, targets, isSingle, confirmResend, closeDialog } =
  useResendInvitations();
</script>
